import Nav from "../components/Nav";

export default function Header() {
  return (
    <header>
      <Nav />
    </header>
  );
}
